module.exports = __webpack_public_path__ + "static/media/milxc-iutAS-step2.413afcb0.png";